import React from 'react';
import { isNum } from '../format';

/** Tiny trend line for stat tiles: de-emphasis line, accent end-dot with a surface ring. */
export default function Sparkline({ values = [], width = 96, height = 30, accent = 'var(--le-s1)' }) {
  const pts = values.filter(isNum);
  if (pts.length < 2) return <svg width={width} height={height} className="le-sparkline" aria-hidden="true" />;
  const min = Math.min(...pts);
  const max = Math.max(...pts);
  const pad = 3;
  const sx = (i) => pad + (i / (pts.length - 1)) * (width - 2 * pad);
  const sy = (v) => (max === min ? height / 2 : pad + (1 - (v - min) / (max - min)) * (height - 2 * pad));
  const d = pts.map((v, i) => `${i === 0 ? 'M' : 'L'}${sx(i).toFixed(1)},${sy(v).toFixed(1)}`).join('');
  const lastX = sx(pts.length - 1);
  const lastY = sy(pts[pts.length - 1]);
  return (
    <svg width={width} height={height} className="le-sparkline" aria-hidden="true">
      <path d={d} className="le-sparkline-path" fill="none" />
      <circle cx={lastX} cy={lastY} r={3.5} className="le-sparkline-dot" style={{ fill: accent }} />
    </svg>
  );
}
